import { useEffect, useState } from 'react'

const DISMISSED_KEY = 'pwa_install_dismissed'

export function usePWAInstall() {
  const [prompt, setPrompt] = useState(null)
  const [isInstalled, setIsInstalled] = useState(false)
  const [isDismissed, setIsDismissed] = useState(
    () => { try { return !!localStorage.getItem(DISMISSED_KEY) } catch { return false } }
  )

  useEffect(() => {
    // Already running as installed PWA
    if (window.matchMedia('(display-mode: standalone)').matches) {
      setIsInstalled(true)
      return
    }

    const handler = (e) => {
      e.preventDefault()
      setPrompt(e)
    }
    window.addEventListener('beforeinstallprompt', handler)

    window.addEventListener('appinstalled', () => {
      setIsInstalled(true)
      setPrompt(null)
    })

    return () => window.removeEventListener('beforeinstallprompt', handler)
  }, [])

  const install = async () => {
    if (!prompt) return false
    prompt.prompt()
    const { outcome } = await prompt.userChoice
    if (outcome === 'accepted') {
      setIsInstalled(true)
      setPrompt(null)
    }
    return outcome === 'accepted'
  }

  const dismiss = () => {
    try { localStorage.setItem(DISMISSED_KEY, '1') } catch {}
    setIsDismissed(true)
    setPrompt(null)
  }

  const canInstall = !!prompt && !isInstalled && !isDismissed

  return { canInstall, isInstalled, install, dismiss }
}
